import { useFlag } from '@/feature/feature-flags'
import { ObservatoryEtaSettings } from '@/feature/observatory'

export const useEtaConfig = (): ObservatoryEtaSettings =>
  useFlag<ObservatoryEtaSettings>('etaConfig', {
    route: {
      layers: [
        {
          colour: '#FFF',
          width: 7,
        },
        {
          colour: '#000000',
          width: 8,
        },
      ],
    },
    parameters: {
      avoid: [],
      trafficModel: 'PESSIMISTIC',
    },
    enabled: false,
  })
